import 'intersection-observer';
import PxsMap from '@pixelunion/pxs-map';
import rimg from '@pixelunion/rimg-shopify';

// jQuery plugins
import './globals/jquery';
import '@pixelunion/jquery-trend';
import '@pixelunion/jquery-revealer';

import $ from 'jquery';
import $script from 'scriptjs';

import flickityTouchFix from './globals/FlickityTouchFix';

// Google maps
import './globals/google-maps';

// Template imports
import accountTemplates from './templates/accountTemplates';
import pageTemplates from './templates/pageTemplates';
import enumerateSections from './templates/enumerateSections';

// Section imports
import Sections from './Sections';
import ContactbarStaticSection from './sections/ContactbarStaticSection';
import DynamicBlogPosts from './sections/DynamicBlogPosts';
import DynamicFeaturedProducts from './sections/DynamicFeaturedProducts';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicTwitter from './sections/DynamicTwitter';
import DynamicVideo from './sections/DynamicVideo';
import GiftCardStaticSection from './sections/GiftCardStaticSection';
import HeaderMiniCart from './components/HeaderMiniCart';
import HeaderStaticSection from './sections/HeaderStaticSection';
import MobileCollectionsDynamicSection from './sections/MobileCollectionsDynamicSection';
import Product from './sections/Product';
import SearchStaticSection from './sections/SearchStaticSection';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import StaticFooter from './sections/StaticFooter';

const sections = new Sections();

rimg.init();

sections.register('dynamic-blog-posts', section => new DynamicBlogPosts(section));
sections.register('dynamic-mobile-collections', section => new MobileCollectionsDynamicSection(section));
sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
sections.register('dynamic-twitter', section => new DynamicTwitter(section));
sections.register('dynamic-video', section => new DynamicVideo(section));
sections.register('static-article', section => new StaticArticle(section));
sections.register('static-blog', section => new StaticBlog(section));
sections.register('static-collection', section => new StaticCollection(section));
sections.register('static-contactbar', section => new ContactbarStaticSection(section));
sections.register('static-header', section => new HeaderStaticSection(section));
sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
sections.register('static-search-results', section => new SearchStaticSection(section));
sections.register('static-footer', section => new StaticFooter(section));

sections.register('pxs-map', section => new PxsMap(section));

// Load sections that require the Shopify API
$script($('[data-scripts]').data('shopify-api-url'), () => {
  sections.register('dynamic-featured-products', section => new DynamicFeaturedProducts(section));
  sections.register('static-product', section => new Product(section));
  sections.register('dynamic-product', section => new Product(section));
  // HeaderMiniCart isn't a real Shopify section, but uses the section postMessage functionality
  sections.register('header-minicart', section => new HeaderMiniCart(section));
});

// Cart
$script($('[data-scripts]').data('shopify-cart-url'), () => {
  sections.register('static-cart', section => new StaticCart(section));
});

// Giftcard
$script($('[data-scripts]').data('shopify-qrcode'), () => {
  sections.register('static-giftcard', section => new GiftCardStaticSection(section));
});


accountTemplates();
pageTemplates();
enumerateSections();
flickityTouchFix();
